import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface CompleteWorkflowParams {
  clientId: string;
}

const completeWorkflow = ({ clientId }: CompleteWorkflowParams) => {
  return authFetch('/Consumer/AutomatedAccountsUpdate/CompleteWorkflow', {
    method: 'POST',
    ...httpBodyOptions({ clientId }),
  });
};

export const useCompleteWorkflowMutation = () => {
  return useMutation(completeWorkflow);
};
